import { MeasuredCookieType } from '@wix/da-shared-react/pkg/Measured';
import { ZoneType } from '../../../../types/layout';
import { BACKGROUNDS } from './constants';

export const getMeasuredCookieType = (zone: ZoneType): MeasuredCookieType => {
  switch (zone) {
    case ZoneType.MID_RIGHT:
      return MeasuredCookieType.LLAMA_FARM_RIGHT;
    case ZoneType.MID_LEFT:
    default:
      return MeasuredCookieType.LLAMA_FARM_LEFT;
  }
};

export const getBackgroundByIndex = (index: number): number =>
  BACKGROUNDS[(index + BACKGROUNDS.length) % BACKGROUNDS.length];
